// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.At = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.At = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var At = _exports.At = function At(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.1564 9.91513C12.9344 12.43 11.178 13.86 9.18431 13.86C7.19065 13.86 5.86368 12.0937 6.0555 9.91513C6.24732 7.73655 7.88594 5.97021 9.8796 5.97021C11.8733 5.97021 13.3477 7.74543 13.1564 9.91513V9.91513Z",
      stroke: "#212B36",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.1443 17.879C11.736 18.4707 10.8129 18.594 9.23489 18.594C4.4418 18.594 0.901232 14.7082 1.32087 9.91516C1.74052 5.12208 5.97145 1.23633 10.7645 1.23633C16.1637 1.23633 19.1317 4.77345 18.7145 9.50736C18.4034 13.0415 16.1449 14.0598 14.9624 13.8502C13.85 13.653 12.9318 12.646 13.1014 10.7189L13.5196 5.9727",
      stroke: "#212B36",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
